export default "__VITE_ASSET__D70yN_mo__"